import { Category } from '@usercentrics/cmp-browser-sdk';
import React from 'react';

import { ContentCategory } from './ContentCategory';

export const ContentCategories = ({ categories }: { categories: Category[] }): JSX.Element => {
  return (
    <div className="uc-space-y-6">
      {categories.map((category: Category) => (
        <ContentCategory key={category.slug} category={category} />
      ))}
    </div>
  );
};
